import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface CreateCareerBreakParams {
  userId: string;
  careerBreak: {
    type: 'retired' | 'no-activity' | 'job-seeker';
    workEligibleFr?: boolean;
    jobSeekerStatus?: boolean;
    jobSearchAreas?: any[]; // TODO: define a more precise type when implementig job search area
  };
  context?: string;
}

const { useCreate: useCreateCareerBreak } = getCRUDHooks({
  entityName: 'careerBreak',
  create: ({ userId, careerBreak, context }: CreateCareerBreakParams) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .careerBreaks.create(
        {
          jobSearchAreas: [],
          ...careerBreak,
        },
        false
      )
      .setHeader('X-Request-Context', context)
      .execute(),
});

// eslint-disable-next-line import/prefer-default-export
export { useCreateCareerBreak };
